import { signOutSession } from '@/entities/session';
import { Button } from '@/shared/ui/shadcn/button';

export default function AutofocusPatientPage() {
  return (
    <div className="dark flex min-h-screen w-full items-center justify-center bg-background text-foreground">
      <div className="max-w-md space-y-3 rounded-lg border border-border bg-card p-6 text-card-foreground shadow-sm">
        <h1 className="text-lg font-semibold">No patients available</h1>
        <p className="text-sm text-muted-foreground">
          You’re signed in, but we couldn’t find any patients to open. If this seems wrong, try
          signing out and back in.
        </p>
        <div className="flex items-center justify-end gap-2">
          <Button type="button" variant="secondary" onClick={() => void signOutSession()}>
            Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
